import { TacheService } from './../../services/tache.service';
import { HistoTacheService } from './../../services/histotache.service';
import { Historiquetache } from './../../models/historiqueTache.model';
import { Component, OnInit } from '@angular/core';
import { Tache } from '../../models/tache.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ngx-app-culture',
  templateUrl: './culture.component.html',
  styleUrls: ['./culture.component.scss']
})
export class CultureComponent implements OnInit {

  culture: Tache[];
  constructor(private tacheService: TacheService,private route: ActivatedRoute) { 
    console.log(this.route.snapshot.queryParams.id);
    this.tacheService.get_tachesBySalle(this.route.snapshot.queryParams.id).subscribe((res: Tache[]) => {
      this.culture = res;
  });
  }

  ngOnInit() {
  }

}
